import "moment/locale/id";
import { CountDown, CountdownTimer, CurrencyFormat, formatDate, formatDate2, formatDate3, formatTime } from "../../../components/helpers";
import Count from "./countPengembalian";
import moment from "moment";
export const convertPengembalian = (data) => {
    let converted = [];

    if (!data) return [];

    data.forEach((item, index) => {
        converted.push({
            key: index + 1,
            id: item.id,
            tanggal_kirim_proses: moment(item.delivery_date).toString() || "-",
            tanggal_kirim: formatDate(item.gadai?.due_date) || "-",
            tanggal_kirim_detail: formatDate2(item.delivery_date) || "-",
            waktu_kirim: formatTime(item.delivery_date) || "-",
            req_kirim: formatDate(item.delivery_date) || "-",
            no_sbg: item.gadai.sbg_code || "-",
            nama_nasabah: item.gadai.customer.ktp_name || "-",
            no_telp: item.gadai.customer.phone_1 || "-",
            barang_jaminan: item.gadai.gadai_type || "-",
            lokasi: !item.gadai.outlet?.name ? "-" : item.gadai.outlet.name,
            alamat: `${item.address}` || "-",
            lokasi_kirim: `${item.address} ${item.subdistrict} ${item.city} ${item.province}` || "-",
            konfirmasi: <Count currentDate={item?.gadai.created_at} />,
            kode_gadai: item.gadai_id || "-",
            kode_kurir: item.employee_id || "-",
            kode_kurir: !item?.employee_id ? "" : item.employee_id || "-",
            nama_kurir: `${item.employee?.first_name} ${item.employee?.last_name}` || "-",
            gadai_picture: item.gadai?.gadai_product_pictures || "-",
            outlet_id: item.employee?.outlet_id || "-"
        });
    });
    return converted;
};
